"use client";

import * as React from "react";
import styled, { css } from "styled-components";
import transition from "../../utils/transition";
import media, { getBreakpointWidth } from "../../utils/mediaQuery";
import defaultTheme from "../../defaultTheme";
import { rtlSpacing } from "../../utils/rtl";
import { ModalContext } from "../ModalContext";
import { QUERIES } from "../../utils/mediaQuery/consts";
import useModalContextFunctions from "../helpers/useModalContextFunctions";
const StyledChild = styled.div.withConfig({
  displayName: "ModalFooter__StyledChild",
  componentId: "sc-1ryeorb-0"
})(["", ";"], ({
  theme,
  flex
}) => css(["flex:", ";box-sizing:border-box;padding:", ";"], flex, rtlSpacing(`0 ${theme.orbit.spaceXSmall} 0 0`)));
StyledChild.defaultProps = {
  theme: defaultTheme
};
export const StyledModalFooter = styled.div.withConfig({
  displayName: "ModalFooter__StyledModalFooter",
  componentId: "sc-1ryeorb-1"
})(["", ""], ({
  theme,
  childrenLength,
  isMobileFullPage
}) => css(["display:flex;z-index:800;width:100%;background-color:", ";padding:", ";box-sizing:border-box;transition:", ";@media (max-width:", "px){.orbit-button-primitive{font-size:", ";height:", ";}}", ";", ":last-of-type{padding:0;}"], theme.orbit.paletteWhite, rtlSpacing(`0 ${theme.orbit.spaceMedium} ${theme.orbit.spaceMedium}`), transition(["box-shadow"], "fast", "ease-in-out"), +getBreakpointWidth(QUERIES.LARGEMOBILE, theme, true) - 1, theme.orbit.fontSizeButtonNormal, theme.orbit.heightButtonNormal, media.largeMobile(css(["justify-content:", ";", ";"], childrenLength > 1 ? "space-between" : "flex-end", !isMobileFullPage && css(["border-bottom-left-radius:9px;border-bottom-right-radius:9px;"]))), StyledChild));
StyledModalFooter.defaultProps = {
  theme: defaultTheme
};
const getChildFlex = (flex, key) => Array.isArray(flex) && flex.length !== 1 ? flex[key] || flex[0] : flex;
const wrappedChildren = (children, flex) => {
  if (!Array.isArray(children)) return children;
  return React.Children.map(children, (child, key) => {
    if (! /*#__PURE__*/React.isValidElement(child)) return null;
    return /*#__PURE__*/React.createElement(StyledChild, {
      flex: getChildFlex(flex, key),
      "data-test": "footer-el-wrapper"
    }, /*#__PURE__*/React.cloneElement(child, {
      // @ts-expect-error React.cloneElement  issue
      ref: child.ref ? node => {
        // Call the original ref, if any
        // @ts-expect-error React.cloneElement  issue
        const {
          ref
        } = child;
        if (typeof ref === "function") {
          ref(node);
        } else if (ref !== null) {
          ref.current = node;
        }
      } : null
    }));
  });
};
const ModalFooter = ({
  dataTest,
  children,
  flex = "0 1 auto"
}) => {
  const {
    isMobileFullPage,
    setFooterHeight
  } = React.useContext(ModalContext);
  const containerRef = React.useRef(null);
  useModalContextFunctions();
  React.useEffect(() => {
    function transitionEndHandler() {
      if (setFooterHeight && containerRef.current) {
        setFooterHeight(containerRef.current.clientHeight);
      }
    }
    const containerEl = containerRef.current;
    containerEl?.addEventListener("transitionend", transitionEndHandler);
    return () => {
      containerEl?.removeEventListener("transitionend", transitionEndHandler);
    };
  }, [setFooterHeight]);
  return /*#__PURE__*/React.createElement(StyledModalFooter, {
    ref: containerRef,
    "data-test": dataTest,
    isMobileFullPage: isMobileFullPage,
    childrenLength: React.Children.toArray(children).length
  }, flex && wrappedChildren(children, flex));
};
export default ModalFooter;